<template>
  <div class="Monthly">
    <div class="Monthly_top">
      <h2 style="color: #fff;font-size: 22px;height: 80px;line-height:80px;margin-left:20px;float: left;">心理中心·月报内容</h2>
      <div @click="Togglefun(1)" :class="Togglenum==1?'Select':''" style="height: 80px;color: rgba(169, 192, 232, 1); cursor: pointer; line-height:80px;margin-left:20%;float: left;position: relative;">全局概览<div v-if="Togglenum==1" class="triangle-down"></div></div>
      <div @click="Togglefun(2)" :class="Togglenum==2?'Select':''" style="height: 80px;color: rgba(169, 192, 232, 1); cursor: pointer; line-height:80px;margin-left:50px;float: left;position: relative;">心理咨询<div class="triangle-down" v-if="Togglenum==2"></div></div>
      <div @click="Togglefun(3)" :class="Togglenum==3?'Select':''" style="height: 80px;color: rgba(169, 192, 232, 1); cursor: pointer; line-height:80px;margin-left:50px;float: left;position: relative;">危机干预<div class="triangle-down" v-if="Togglenum==3"></div></div>
      <div class="yuefen" style="position: absolute;right:255px;top:20px;width: 170px;">
        <div style="float: left;width: 80px;height: 40px;background: rgba(75, 108, 166, 1);color: #fff;line-height:40px;text-align: center;">统计月份</div>
        <el-select style="float: left;width: 90px;" v-model="region" placeholder="月份" @change='yuefenfun'>
          <el-option label="一月" value="01"></el-option>
          <el-option label="二月" value="02"></el-option>
          <el-option label="三月" value="03"></el-option>
          <el-option label="四月" value="04"></el-option>
          <el-option label="五月" value="05"></el-option>
          <el-option label="六月" value="06"></el-option>
          <el-option label="七月" value="07"></el-option>
          <el-option label="八月" value="08"></el-option>
          <el-option label="九月" value="09"></el-option>
          <el-option label="十月" value="10"></el-option>
          <el-option label="十一月" value="11"></el-option>
          <el-option label="十二月" value="12"></el-option>
        </el-select>
      </div>

      <el-button v-if="zhuti == 2" style="position: absolute;top:23px;right:120px" @click="qiehuanzhut(1)" type="primary" icon="el-icon-sunny">白昼主题</el-button>
      <el-button v-if="zhuti == 1" style="position: absolute;top:23px;right:120px" @click="qiehuanzhut(2)" type="primary" icon="el-icon-moon">暗色主题</el-button>
      <!-- <el-button style="position: absolute; visible: false; top:23px;right:20px" type="primary" icon="el-icon-upload2">导出</el-button> -->

    </div>
    <div class="nav" :class="Togglenum == 1?'nav1':'no'">
      <p style="color: var(--Monthly3);text-align: left;vertical-align: top;font-size: 18px;padding-top:20px;margin-left:20px">国科大心理中心</p>

      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">截止{{datasgetFullYear}}年{{datasgetMonth}}月{{datasgetDate}}号向我校学生 <span style="color: var(--Monthly3);">{{alldata.allStudentCount}}</span> 人、联合培养学生  <span style="color: var(--Monthly3);">{{alldata.allAppointCount}}</span>   人以及校部教职工  <span style="color: var(--Monthly3);">{{alldata.allTeacherCount}}</span>  人提供专业心理服务。</p>

      <ul class="nav-ul">
        <li>
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff;text-indent: 20px;">供应时长</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata.allSupplyCount}}h</p>
        </li>
        <li style="margin-left:-1px">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">可约时长</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata.allAppointCount}}h</p>
        </li>
        <li style="margin-left:-1px">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">排队人数</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata.allAppointPersonCount}}人</p>
        </li>
      </ul>

      <ul class="complete2">
        <li class="item" style="width: 200px;border-right:1px solid  rgba(109, 128, 156, 1)">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">国科大籍学生统计</p>
          <p @click="consultPersonCountXJfun(1)" :class="consultPersonCountXJfunnnum==1?'Select2':''" style="height: 40px;line-height:40px;text-align:center;color: #fff;background: rgba(57, 70, 92, 1);border-radius: 4px;width: 90%;margin-left:5%;margin-top:10px;cursor: pointer;">国科大学籍</p>
          <p @click="consultPersonCountXJfun(2)" :class="consultPersonCountXJfunnnum==2?'Select2':''" style="height: 40px;line-height:40px;text-align:center;color: #fff;background: rgba(57, 70, 92, 1);border-radius: 4px;width: 90%;margin-left:5%;margin-top:10px;cursor: pointer;">国科大联培生</p>
          <p @click="consultPersonCountXJfun(3)" :class="consultPersonCountXJfunnnum==3?'Select2':''" style="height: 40px;line-height:40px;text-align:center;color: #fff;background: rgba(57, 70, 92, 1);border-radius: 4px;width: 90%;margin-left:5%;margin-top:10px;cursor: pointer;">全部</p>
        </li>
        <li style="width: calc(100% - 202px);">
          <!-- <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">各服务情况完成人次</p> -->
          <div ref="consultPersonCountXJ" style="width: 100%;background-color: var(--Monthly1);height: 240px;margin-top:20px"></div>
        </li>
      </ul>

      <div class="complete2" style="height: 450px;border:none">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">各部门单位风险等级人数分布</p>
        <div ref="studentRiskCounts" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>

      <div class="complete2" style="height: 450px;border:none">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px;">咨询人次统计</p>
        <ul class="sjli">
          <li style="cursor: pointer;" @click="xqfun('',-1)" :class="xqfunnum == -1?'aa':''">全部</li>
          <li style="cursor: pointer;" v-for="(item,i) in GetDictionaryList" :key="i" @click="xqfun(item.ConAddressID,i)" :class="xqfunnum == i?'aa':''">{{item.ConAddressName}}</li>
        </ul>
        <div ref="new3" style="width: 100%;background-color: var(--Monthly1);height: 400px;margin-top:50px"></div>
      </div>

      <div class="complete2" style="height: 550px;border:none">
        <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">院系参与心理活动人数前十排行</p>
        <div ref="studentCounts" style="width: 100%;height: 100%;margin-top:30px"></div>
      </div>

      <div class="complete2" style="height: 450px;border:none;margin-top:90px">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">宣传热门标签排行</p>
        <div ref="xurm" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>


      <div class="complete2" style="height: 450px;border:none;margin-top:90px;">
        <!-- <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">阅读量</p> -->

        <div style="width: 1200px;height: 500px;margin:auto;">
          <div ref="education"  style="width: 500px;height: 500px;float:left;margin-left:100px;"></div>
          <div ref="education2" style="width: 500px;height: 500px;float:left;margin-left:100px;"></div>
        </div>

      </div>


    </div>
    <!-- --------------------------------------------------心理咨询------------------------------------ -->
    <div :class="Togglenum==2?'nav':'no'" class="nav" style="position: relative;">

      <p style="color: var(--Monthly3);text-align: left;vertical-align: top;font-size: 18px;padding-top:20px;margin-left:20px">国科大心理中心</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">本月提供个体心理咨询预约个体咨询 <span style="color: var(--Monthly3);">{{alldata2.allConsultCount}}</span> 人次、
          
        线上咨询<span style="color:  var(--Monthly3);">  {{alldata2.allConsultTimesOnline}}</span> 人次、线下咨询<span style="color:  var(--Monthly3);">  {{alldata2.allConsultTimesOffline}}</span> 人次、
        排队  <span style="color:  var(--Monthly3);">  {{alldata2.allWaitAllCount}}</span> 人次、实际完成咨询  <span style="color:  var(--Monthly3);">{{alldata2.allCompleteCount}}</span>人次。</p>

      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">本月开展团体咨询 <span style="color:  var(--Monthly3);">{{totalCount}}</span> 组 <span style="color:  var(--Monthly3);">{{totalHours}}</span> 小时，共有  <span style="color: var(--Monthly3);">{{totalPeople}}</span> 名学生参与，线下 <span style="color: var(--Monthly3);">{{totalCountOffline}}</span> 小组  <span style="color:  var(--Monthly3);">{{totalPeopleOffline}}</span> 人、线上 <span style="color: var(--Monthly3);">{{totalCountOnline}}</span> 小组  <span style="color:  var(--Monthly3);">{{totalPeopleOnline}}</span> 人。</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">本月心理咨询中，当事人主诉议题有
        <span v-for="(item,i) in alldata2.totalConsultByThemes" :key="i" style="color: var(--Monthly2);">{{item.theme}} <span style="color:  var(--Monthly3);">{{item.total}}</span>  例{{alldata2.totalConsultByThemes.length-1==i?'。':'、'}}</span>
      </p>

        <!-- 学业问题 <span style="color:  var(--Monthly3);">{{alldata2.academicCount}}</span>  例、关系问题 <span style="color:  var(--Monthly3);">{{alldata2.relationCount}}</span> 例、情绪问题  <span style="color: var(--Monthly3);">{{alldata2.emotionCount}}</span> 例、</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">本月咨询中发现危机个案 <span style="color:  var(--Monthly3);">{{alldata2.crisisCase}}</span> 例，</p> -->
        
        <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">
        涉及自杀自伤风险 <span style="color: var(--Monthly3);">{{alldata2.suicide}}</span> 例、精神病性症状 <span style="color:  var(--Monthly3);">{{alldata2.mental}}</span> 例，开展二次评估 <span style="color:  var(--Monthly3);">{{alldata2.secondEvaluation}}</span> 例，保密突破启动危机干预  <span style="color:  var(--Monthly3);">{{alldata3.securityBreak}}</span> 例。</p>
        <!-- <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);line-height:24px">当前可预约时段：  
        <span v-for="(item,i) in alldata2.consultTimes" :key="i" style="color:var(--Monthly2);margin-left:20px;">
          {{item.timeZone}} <i style="color:var(--Monthly3);font-style: normal;">余({{item.remainderCount}})</i>
        </span>
        {{alldata2.consultTimes}}
        </p> -->
      <ul class="nav-ul">
        <li>
          <p style="width:100%;height:40px;line-height:40px;background:rgba(58, 86, 135, 1);color:#fff;text-indent:20px;">预约总人数</p>
          <p style="height:calc(100% - 40px);line-height:160px;text-align:center;color:var(--Monthly2);font-size:36px;">{{mubns1}}人</p>
        </li>
        <li style="margin-left:-1px;">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff;text-indent: 20px;">实际咨询人数</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{mubns2}}人</p>
        </li>
        <li style="margin-left:-1px">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">长期咨询人数</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{mubns3}}人</p>
        </li>
      </ul>

      <div class="complete2" style="height: 450px;border:none">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px;">咨询人次统计</p>
        <ul class="sjli">
          <!-- <li>数据来源2</li> -->
          <li style="cursor: pointer;" @click="xlrcfun('',-1)" :class="xlrcfunnum == -1?'aa':''">全部</li>
          <li style="cursor: pointer;" v-for="(item,i) in GetDictionaryList" :key="i" @click="xlrcfun(item.ConAddressID,i)" :class="xlrcfunnum == i?'aa':''">{{item.ConAddressName}}</li>
        </ul>
        <div ref="news1" style="width: 100%;background-color: var(--Monthly1);height: 400px;margin-top:50px"></div>
      </div>

      <div class="complete2" style="height: 450px;border:none;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">咨询人次学业阶段占比</p>
        <div ref="consultCountDegrees" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>
      <div class="complete2" style="height: 450px;border:none;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">咨询人次角色分类占比</p>
        <div ref="consultCountRoles" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>
      <div class="complete2" style="height: 450px;border:none;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px;">各咨询主题人次统计</p>
        <ul class="sjli"> 

          <li style="cursor: pointer;" @click="zxztfun('',0-1)" :class="zxztfunnum == -1?'aa':''">全部</li>
          <li style="cursor: pointer;" v-for="(item,i) in GetDictionaryList2" :key="i" @click="zxztfun(item.dicKey,i)" :class="zxztfunnum == i?'aa':''">{{item.cDicValue}}</li>
        </ul>
        <div ref="appointConsultByThemes" style="width: 100%;background-color: var(--Monthly1);height: 400px;margin-top:50px"></div>
      </div>
      <ul class="sjli" style="margin-top:40px;margin-left:20px">
        <li style="cursor: pointer;" @click="xlyyfun('',4)" :class="xlyyfunnum == 4?'aa':''">全部</li>
        <li style="cursor: pointer;" @click="xlyyfun('本科生',1)" :class="xlyyfunnum == 1?'aa':''">本科生</li>
        <li style="cursor: pointer;" @click="xlyyfun('硕士研究生',2)" :class="xlyyfunnum == 2?'aa':''">硕士研究生</li>
        <li style="cursor: pointer;" @click="xlyyfun('博士研究生',3)" :class="xlyyfunnum == 3?'aa':''">博士研究生</li>
      </ul>
      <div class="complete2" style="height: 450px;border:none;margin-top:100px;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">各学业阶段预约人次</p>
        <div ref="consultCountCampusDegrees" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>
      <ul class="sjli" style="margin-top:40px;margin-left:20px">
        <li style="cursor: pointer;"  :class="jsyyfunnum == 6?'aa':''" @click="jsyyfun('',6)"      >全部</li>
        <li style="cursor: pointer;"  :class="jsyyfunnum == 1?'aa':''" @click="jsyyfun('本科部',1)">本科部</li>
        <li style="cursor: pointer;"  :class="jsyyfunnum == 2?'aa':''" @click="jsyyfun('院系',2)"  >院系</li>
        <li style="cursor: pointer;"  :class="jsyyfunnum == 3?'aa':''" @click="jsyyfun('研究所',3)">研究所</li>
        <li style="cursor: pointer;"  :class="jsyyfunnum == 4?'aa':''" @click="jsyyfun('联培生',4)">联培生</li>
        <li style="cursor: pointer;"  :class="jsyyfunnum == 5?'aa':''" @click="jsyyfun('教职工',5)">教职工</li>
      </ul>
      <div class="complete2" style="height: 450px;border:none;margin-top:100px;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">各角色预约人次</p>
        <div ref="consultCountCampusRoles" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>
    </div>
<!----------------------------------------------------危机干预-------------------------------------->
<!-- <div :class="Togglenum==2?'nav':'no'" class="nav" style="position: relative;"> -->
    <div :class="Togglenum == 3?'nav3':'no'" class="nav">
      <p style="color: var(--Monthly2);text-align: left;vertical-align: top;font-size: 18px;padding-top:20px;margin-left:20px">国科大心理中心</p>
      <p style="margin-top:10px;color: var(--Monthly2);margin-left:20px;">当前，纳入风险台账进行重点关注的学生 <span style="color: var(--Monthly3)">{{alldata3.totalFocus}}</span> 人，涉及 <span style="color: var(--Monthly3)">{{alldata3.unitNum}}</span> 个培养单位。</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">本月开展心理危机干预 <span style="color: var(--Monthly3)">{{alldata3.monthCrisisNum}}</span> 例、涉及 <span style="color:  var(--Monthly3)">{{alldata3.involveUnit}}</span> 个培养单位，已保密突破联系家人 <span style="color:  var(--Monthly3)">{{alldata3.securityBreak}}</span> 例、就医诊断 <span style="color:  var(--Monthly3)">{{alldata3.medicalService}}</span> 例、干预稳定后转至心理咨询 <span style="color:  var(--Monthly3)">{{alldata3.toConsultNum}}</span> 例。</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">本月热线来电中校内五级 <span style="color: rgba(240, 188, 17, 1);">{{alldata3.hotLineFiveLevel}}</span> 例、四级 <span style="color: rgba(240, 188, 17, 1);">{{alldata3.hotLineFourLevel}}</span> 例、三级 <span style="color: rgba(240, 188, 17, 1);">{{alldata3.hotLineThreeLevel}}</span> 例，启动校内危机干预 <span style="color: rgba(240, 188, 17, 1);">{{alldata3.schoolCrisis}}</span> 例。</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">本月咨询中发现危机个案 <span style="color: rgba(240, 188, 17, 1);">{{alldata3.crisisCase}}</span> 例，涉及自杀自伤风险 <span style="color: rgba(240, 188, 17, 1);">{{alldata3.suicide}}</span> 例、精神病性症状 <span style="color: rgba(240, 188, 17, 1);">{{alldata3.mental}}</span>例，开展二次评估<span style="color: rgba(240, 188, 17, 1);">{{alldata3.secondAssess}}</span>例，保密突破启动危机干预 <span style="color: rgba(240, 188, 17, 1);">{{alldata3.cousultSecurityBreak}}</span> 例。</p>
      <ul class="nav-ul">

        <li style="width: calc(25% - 2px);">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">重点关注人数</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata3.totalCrisis}}人</p>
        </li>

        <li style="margin-left:-1px;width: calc(25% - 2px);">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff;text-indent:20px;">涉及培养单位数量</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata3.unitNum}}个</p>
        </li>

        <li style="margin-left:-1px;width: calc(25% - 2px);">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">涉及自杀自伤风险案例</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata3.suicideCrisis}}例</p>
        </li>

        <li style="margin-left:-1px;width: calc(25% - 2px);">
          <p style="width: 100%;height: 40px;line-height:40px;background:rgba(58, 86, 135, 1);color: #fff;text-indent:20px;">严重精神障碍</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata3.psychosesCrisis}}人</p>
        </li>

      </ul>

      <div class="complete2" style="height: 450px;border:none;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px;">各单位危机预警人数统计</p>
        <ul class="sjli"> 
          <li style="cursor: pointer;" v-for="(item,i) in GetDictgd" :key="i" @click="fxfun(item.dicKey,i)" :class="fxfunnum == i?'aa':''">{{item.ConAddressName}}</li>
        </ul>
        <div ref="crisisByCampusList" style="width: 100%;background-color: var(--Monthly1);height: 400px;margin-top:50px"></div>
      </div>

      <div class="complete2" style="height: 750px;border:none;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px;">各学业阶段风险等级人数分布</p>
        <div ref="crisisNumByRoles"  style="width: 100%;background-color: var(--Monthly1);height:400px;"></div>
        <div ref="crisisNumByRoles2" style="width: 100%;background-color: var(--Monthly1);height:400px;"></div>
      </div>

      <div class="complete2" style="height: 450px;border:none;margin-top:70px;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">各学历危机人数</p>
        <ul class="sjliaca" style="height: 28px;margin-left:30px;margin-top:20px;">
          <li style="cursor: pointer;float: left;color: #fff;padding:0px 20px;line-height:28px" @click="scrfun('本科',1)" :class="scrfunnum == 1?'fffs':''">本科</li>
          <li style="cursor: pointer;float: left;color: #fff;padding:0px 20px;line-height:28px" @click="scrfun('硕士',2)" :class="scrfunnum == 2?'fffs':''">硕士</li>
          <li style="cursor: pointer;float: left;color: #fff;padding:0px 20px;line-height:28px" @click="scrfun('博士',3)" :class="scrfunnum == 3?'fffs':''">博士</li>
          <li style="cursor: pointer;float: left;color: #fff;padding:0px 20px;line-height:28px" @click="scrfun('联培生',4)" :class="scrfunnum == 4?'fffs':''">联培生</li>
        </ul>
        <div ref="crisisNumByDegrees" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>

      <div class="complete2" style="height: 450px;border:none;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px;">风险等级人数按性别分布</p>
        <div ref="crisisNumBySexes" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>

      <div class="complete2" style="height: 450px;border:none;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px;">各部门单位风险人数等级</p>
        <div ref="crisisNumByDept" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>

      <div class="complete2" style="height: 450px;border:none;">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px;">月份危机人数/等级动态变化</p>
        <div ref="crisisNumByMonth" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>

    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      GetDictgd:[
        {
          dicKey:'1',
          ConAddressName:'院系'
        },
        {
          dicKey:'2',
          ConAddressName:'京内研究所'
        },
        {
          dicKey:'3',
          ConAddressName:'京外研究所'
        },
      ],
      Togglenum:'1',
      qiehuannum:'1',
      region:'',
      zhuti:2,
      month:'',
      alldata:[],
      alldata2:[],
      alldata3:[],
      datas:'',
      datasgetFullYear:'',
      datasgetMonth:'',
      datasgetDate:'',
      consultPersonCountXJfunnnum:'1',
      GetDictionaryList:[],
      campusKey:'',
      GetDictionaryList2:[],
      campusKey2:'',
      xqfunnum:0,
      fxfunnum:0,
      fxcampusKey:'',
      mubns1:'',
      mubns2:'',
      mubns3:'',
      fxxlfunnum:'',
      scrfunnum:'1',
      fxxlrole:'',
      scrlrole:'本科',
      xlrcfunnum:'',
      xlrccampusKey:'',
      zxztthemeKey:'',
      zxztfunnum:'',
      xlyyfunnum:'4',
      zxztdegree:'',
      jsyyfunnum:'6',
      jsrole:'',
      totalCount:'',
      totalCountOffline:'',
      totalCountOnline:'',
      totalHours:'',
      totalPeople:'',
      totalPeopleOffline:'',
      totalPeopleOnline:'',
    }
  },
  mounted() {
    if((Number(new Date().getMonth().toString())+1) <10){
      this.region = '0' + (Number(new Date().getMonth()) + 1)
    }else{
      this.region = (Number(new Date().getMonth())+1)
    }
    this.month = new Date().getFullYear() + '-' + this.region;
    this.$Http_Post("ConsultSubscribe/GetConAddress").then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetDictionaryList = res.Data;
        this.campusKey = res.Data[0].ConAddressID;

        this.$Http_Post("User/GetDictionaryList",{DicTypCode: '25'}).then((res2) => {
          if (res2.Code == 200 || res2.Code == 0) {
            this.GetDictionaryList2 = res2.Data;
            this.campusKey2 = res2.Data[0].dicKey;
            this.loading();
            this.loading2();
            this.loading3();
          } else {
            this.Global.request_failure(res2.Message);
          }
        })
      } else {
        this.Global.request_failure(res.Message);
      }
    })
    this.datas = new Date();
    this.datasgetFullYear = this.datas.getFullYear();
    this.datasgetMonth    = this.datas.getMonth() + 1;
    this.datasgetDate     = this.datas.getDate();
  },
  methods: {
    education(){
      var myChart = this.$echarts.init(this.$refs.education);
      var option = {
        title: {
          textStyle:{fontSize: 16,color:'#ffffff'},
          text:'阅读量(学历)',
          left:'20px',
          top:'0px',
        },
        tooltip: {
          trigger:'item'
        },
        color:['#93C22D','#557CD9','#E3B540'],
        legend:{
          top:'5%',
          left:'center',
          textStyle:{color:'rgba(109,128,156,1)'},
        },
        series:[
          {
            type:'pie',
            radius:['40%','60%'],
            data:[
              {value:this.alldata.publicEduAndSex.edu.benke,name:'本科生'},
              {value:this.alldata.publicEduAndSex.edu.suosi,name:'硕士生'},
              {value:this.alldata.publicEduAndSex.edu.bosi, name:'博士生'},
            ]
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    education2(){
      var myChart = this.$echarts.init(this.$refs.education2);
      var option = {
        title:{
          textStyle: {fontSize:16,color:'#ffffff'},
          text:'阅读量(性别)',
          left:'20px',
          top:'0px',
        },
        tooltip:{
          trigger:'item'
        },
        color:['#93C22D','#557CD9'],
        legend:{
          top:'5%',
          left:'center',
          textStyle:{color:'rgba(109,128,156,1)'},
        },
        series:[
          {
            type:'pie',
            radius:['40%','60%'],
            data: [
              {value:this.alldata.publicEduAndSex.sex.boy,name:'男'},
              {value:this.alldata.publicEduAndSex.sex.girl,name:'女'},
            ]
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize",function () {
        myChart.resize();
      });
    },
    xurm(){
      var yx = [];
      var sl = [];
      for(var i = 0;i<this.alldata.studentRiskCounts.length;i++){
        yx.push(
          {
            value: this.alldata.studentRiskCounts[i].studentRiskCount, name: this.alldata.studentRiskCounts[i].deptName,itemStyle: { color: this.alldata.studentRiskCounts[i].color}
          }
        )
      }
      var myChart = this.$echarts.init(this.$refs.xurm);
      var option = {
        tooltip:{
          trigger:'item'
        },
        legend:{
          top:'5%',
          left:'center',
          textStyle:{color:'rgba(109,128,156,1)'},
        },
        title:{
          textStyle:{fontSize:16,color:'#ffffff'},
          left:'20px',
          top:'10px'
        },
        series:[
          {
            type:'pie',
            radius:['50%','70%'],
            center:['50%','55%'],
            label:{show:true,formatter(param){return param.name+'('+param.percent+'%)'}},
            data:yx
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize",function () {
        myChart.resize();
      });
    },
    xqfun(val,i){
      this.xqfunnum = i;
      this.campusKey = val;
      this.loading();
    },
    xlrcfun(val,i){
      this.xlrcfunnum = i;
      this.xlrccampusKey = val;
      this.loading2();
    },
    zxztfun(val,i){
      this.zxztfunnum = i;
      this.zxztthemeKey = val;
      this.loading2();
    },
    jsyyfun(val,i){
      this.jsyyfunnum = i;
      this.jsrole = val;
      this.loading2();
    },
    xlyyfun(val,i){
      this.xlyyfunnum = i;
      this.zxztdegree = val;
      this.loading2();
    },
    fxfun(val,i){
      this.fxfunnum = i;
      this.fxcampusKey = val;
      this.loading3();
    },
    fxxlfun(val,i){
      this.fxxlfunnum = i;
      this.fxxlrole = val;
      this.loading3();
    },
    scrfun(val,i){
      this.scrfunnum = i;
      this.scrlrole = val;
      this.loading3();
    },
    yuefenfun(){
      this.month = new Date().getFullYear() + '-' + this.region;
      this.loading();
      this.loading2();
      this.loading3();
    },
    loading(){
      this.$Http_Post("paper/monthreport/getmonthdata",{month: this.month,campusKey:this.campusKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.alldata = res.Data;
          this.education();
          this.education2();
          this.consultPersonCountXJ();//111111111111
          this.studentRiskCounts();//111111111111111
          this.xurm();//宣传热门
          this.new3();//11111111111
          this.studentCounts();//111111111
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    // this.month
    loading2(){
      this.$Http_Post("paper/monthreport/getmonthdataconsult",{"month": this.month,"campusKey": this.xlrccampusKey,"themeKey":this.zxztthemeKey,"role":this.jsrole,"degree":this.zxztdegree}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.alldata2 = res.Data;
          this.mubns1 = res.Data.reserveCountEntity.reserveCount;
          this.mubns2 = res.Data.reserveCountEntity.consultCount;
          this.mubns3 = res.Data.reserveCountEntity.longConsultCount;
          this.totalCount = res.Data.groupConsult.totalCount;
          this.totalCountOffline = res.Data.groupConsult.totalCountOffline;
          this.totalCountOnline = res.Data.groupConsult.totalCountOnline;
          this.totalHours = res.Data.groupConsult.totalHours;
          this.totalPeople = res.Data.groupConsult.totalPeople;
          this.totalPeopleOffline = res.Data.groupConsult.totalPeopleOffline;
          this.totalPeopleOnline = res.Data.groupConsult.totalPeopleOnline;
          this.news1();
          this.consultCountDegrees();
          this.consultCountRoles();
          this.consultCountCampusDegrees();
          this.consultCountCampusRoles();
          this.appointConsultByThemes();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    loading3(){
      // {"month":this.month,}this.month
      this.$Http_Post("paper/monthreport/getmonthdatacrisis",{"month": this.month,"campusKey": this.fxcampusKey,"role":this.fxxlrole,"degree":this.scrlrole}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.alldata3 = res.Data;
          this.crisisByCampusList();
          this.crisisNumByRoles();
          this.crisisNumByRoles2();
          this.crisisNumBySexes();
          this.crisisNumByDegrees();
          this.crisisNumByDept();
          this.crisisNumByMonth();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    qiehuanzhut(val){
      // 2白1黑
      this.zhuti = val
      if(val ==2){//黑
        document.documentElement.style.setProperty('--Monthly1', 'rgb(30, 45, 66)');
        document.documentElement.style.setProperty('--Monthly2', 'rgb(255, 255, 255)');
        document.documentElement.style.setProperty('--Monthly3', 'rgb(240, 188, 17)');
      }else{//2白
        document.documentElement.style.setProperty('--Monthly1', 'rgb(255, 255, 255)');
        document.documentElement.style.setProperty('--Monthly2', 'rgb(0, 0, 0)');
        document.documentElement.style.setProperty('--Monthly3', 'rgb(42, 130, 228)');
      }
    },
    consultPersonCountXJfun(num){
      this.consultPersonCountXJfunnnum = num;
      this.consultPersonCountXJ();
    },
    qiehuanfun(num){
      this.qiehuannum = num;
    },
    Togglefun(num){
      this.Togglenum = num;
    },
    handleClick(val){},
    anxietyAn2(){
      var myChart = this.$echarts.init(this.$refs.anxietyAn2);
      var option = {
        legend: {
          y: "5%", //延Y轴居中
          textStyle: {
            color: '#ffffff',//字体颜色
          },
          itemHeight: 10,
        },
        textStyle: {
          color: "#fff" 
        },
        xAxis: {
          type: 'category',
          data: ['雁栖湖','玉泉路','中关村','奥运村','岳阳路','小洪山','宁卧庄'],
          axisLine:{
            lineStyle:{
              show:true,//是否显示坐标轴轴线，
              color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{
              show:true,//是否显示坐标轴轴线，
              color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
          splitLine:{
            lineStyle:{
              type:'dashed',
              color:'rgba(255, 255, 255, 0.15)',
            }
          }
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
            itemStyle: {
              color: 'rgba(23, 107, 153, 1)',
            },
            barWidth:'30px'
          }
        ]
      }
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    anxietyAn3(){
      var myChart = this.$echarts.init(this.$refs.anxietyAn3);
      var option = {
        legend: {
          y: "5%", //延Y轴居中
          textStyle: {
            color: '#ffffff',//字体颜色
          },
          itemHeight: 10,
        },
        textStyle: {
          color: "#fff" 
        },
        xAxis: {
          type: 'category',
          data: ['雁栖湖','玉泉路','中关村','奥运村','岳阳路','小洪山','宁卧庄'],
          axisLine:{
            lineStyle:{
              show:true,//是否显示坐标轴轴线，
              color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{
              show:true,//是否显示坐标轴轴线，
              color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
          splitLine:{
            lineStyle:{
              type:'dashed',
              color:'rgba(255, 255, 255, 0.15)',
            }
          }
        },
        series: [
          {
            data: [120,200,150,80,70,110,130],
            type: 'bar',
            itemStyle: {
              color: 'rgba(166, 139, 53, 1)',
            },
            barWidth:'30px'
          }
        ]
      }

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    anxietyAn4(){
      var myChart = this.$echarts.init(this.$refs.anxietyAn4);
      var option = {
        legend: {
          y: "5%", //延Y轴居中
          textStyle: {
            color: '#ffffff',//字体颜色
          },
          itemHeight: 10,
        },
        textStyle: {
          color: "#fff" 
        },
        xAxis: {
          type: 'category',
          data: ['雁栖湖','玉泉路','中关村','奥运村','岳阳路','小洪山','宁卧庄'],
          axisLine:{
            lineStyle:{
                show:true,//是否显示坐标轴轴线，
                color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{
                show:true,//是否显示坐标轴轴线，
                color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
          splitLine:{
            lineStyle:{
              type:'dashed',
              color:'rgba(255, 255, 255, 0.15)',
            }
          }
        },
        series: [
          {
            data: [120,200,150,80,70,110,130],
            type: 'bar',
            itemStyle: {
              color: 'rgba(23, 107, 153, 1)',
            },
            barWidth:'30px'
          }
        ]
      }
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    anxietyAn5(){
      var myChart = this.$echarts.init(this.$refs.anxietyAn5);
      var option = {
        legend: {
          y: "5%", //延Y轴居中
          textStyle: {
            color: '#ffffff',//字体颜色
          },
          itemHeight: 10,
        },
        textStyle: {
          color: "#fff" 
        },
        xAxis: {
          type: 'category',
          data: ['雁栖湖','玉泉路','中关村','奥运村','岳阳路','小洪山','宁卧庄'],
          axisLine:{
            lineStyle:{
              show:true,//是否显示坐标轴轴线，
              color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{
              show:true,//是否显示坐标轴轴线，
              color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
          splitLine:{
            lineStyle:{
              type:'dashed',
              color:'rgba(255, 255, 255, 0.15)',
            }
          }
        },
        series: [
          {
            data: [120,200,150,80,70,110,130],
            type: 'bar',
            itemStyle: {
              color: 'rgba(23, 107, 153, 1)',
            },
            barWidth:'30px'
          }
        ]
      }
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    anxietyAndDepressionStatistic2(){
      var myChart = this.$echarts.init(this.$refs.anxietyAndDepressionStatistic2);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          y: "5%", //延Y轴居中
          textStyle: {
            color: '#ffffff',//字体颜色
          },
          itemHeight: 10,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        textStyle: {
          color: "#fff" 
        },
        xAxis: {
          type: 'category',
          data: ['雁栖湖','玉泉路','中关村','奥运村','岳阳路','小洪山','宁卧庄'],
          axisLine:{
            lineStyle:{
              show:true,//是否显示坐标轴轴线，
              color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{
              show:true,//是否显示坐标轴轴线，
              color:'rgba(109, 128, 156, 1)',//x轴轴线的颜色
            }
          },
          splitLine:{
            lineStyle:{
              type:'dashed',
              color:'rgba(255, 255, 255, 0.15)',
            }
          }
        },
        series: [
          {
            name: '预约人次',
            type: 'bar',
            data: [203,489,34,970,744,230,100],
            itemStyle: {
              color: 'rgba(39, 120, 163, 1)',
            },
            barWidth:'20px'
          },
          {
            name: '排队人次',
            type: 'bar',
            data: [325,438,100,1594,141,807,100],
            itemStyle: {
              color: 'rgba(166, 139, 53, 1)',
            },
            barWidth:'20px'
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    consultPersonCountXJ(){
      var xx = [];//休学
      var zx = [];//在校
      var xl = [];//心理等级

      if(this.consultPersonCountXJfunnnum == 1){
        this.alldata.consultPersonCountXJ.forEach(person => {
            if (person.state == 1) {
                zx.push(person.consultPersonCount);
                xl.push(person.degree);
            } else if (person.state == 2) {
                xx.push(person.consultPersonCount);
            }
        });
      }else if(this.consultPersonCountXJfunnnum == 2){
        this.alldata.consultPersonCountLP.forEach(person => {
            if (person.state == 1) {
                zx.push(person.consultPersonCount);
                xl.push(person.degree);
            } else if (person.state == 2) {
                xx.push(person.consultPersonCount);
            }
        });
      }else if(this.consultPersonCountXJfunnnum == 3){
        // 合并 consultPersonCountXJ 和 consultPersonCountLP 的数据
        const combinedData = [...this.alldata.consultPersonCountXJ, ...this.alldata.consultPersonCountLP];
        const combinedResults = {};
        combinedData.forEach(person => {
            const key = `${person.degree}-${person.state}`;
            if (!combinedResults[key]) {
                combinedResults[key] = {
                    degree: person.degree,
                    state: person.state,
                    consultPersonCount: 0
                };
            }
            combinedResults[key].consultPersonCount += person.consultPersonCount; // 累加相同 degree 和 state 的 consultPersonCount
        });

      // 将结果推入 zx 和 xl
      for (const result of Object.values(combinedResults)) {
        if (result.state == 1) {
            zx.push(result.consultPersonCount);
            xl.push(result.degree);
        } else if (result.state == 2) {
            xx.push(result.consultPersonCount);
            }
        }
      }
      var myChart = this.$echarts.init(this.$refs.consultPersonCountXJ);
      var option = {
        // tooltip: {
        //   trigger: 'axis',
        //   axisPointer: {type: 'shadow'}
        // },
        tooltip: {
          position: function (point, params, dom, rect, size) {
            return [point[0], point[1] - 10];  // 上方 10 像素处
          },
        },
        legend: { y: "5%", textStyle: {color: 'rgba(109, 128, 156, 1)'},itemHeight: 10},
        grid: {left: '3%',right: '4%',bottom: '3%',containLabel: true},
        textStyle: {color: 'rgba(109, 128, 156, 1)'},
        xAxis: {
          type: 'category',
          data: xl,
          axisLine:{
            lineStyle:{show:true,color:'rgba(109, 128, 156, 1)',}
          },
        },
        yAxis: {
          type: 'value',
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
          splitLine:{lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}}
        },
        series: [
          {
            name: '休学',
            type: 'bar',
            data: xx,
            itemStyle: {color: 'rgba(227, 181, 32, 1)'},
            barWidth:'20px',
            position: 'top'
          },
          {
            name: '在校',
            type: 'bar',
            data: zx,
            itemStyle: {color: 'rgba(60, 177, 240, 1)'},
            barWidth:'20px',
            position: 'top'
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    studentRiskCounts(){
      var yx = [];
      var sl = [];
      for(var i = 0;i<this.alldata.studentRiskCounts.length;i++){
        yx.push(
          {
            value:this.alldata.studentRiskCounts[i].studentRiskCount,name:this.alldata.studentRiskCounts[i].deptName,itemStyle:{color: this.alldata.studentRiskCounts[i].color}
          }
        )
      }
      var myChart = this.$echarts.init(this.$refs.studentRiskCounts);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        title: {
          textStyle: { fontSize: 16, color: '#ffffff' },
          left: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%','70%'],
            center: ['50%','55%'],
            label: {show: true,formatter(param) {return param.name + '(' + param.percent + '%)'}},
            data: yx
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    consultCountDegrees(){
      var yx = [];
      var sl = [];
      for(var i = 0;i<this.alldata2.consultCountDegrees.length;i++){
        yx.push(
          {
            value: this.alldata2.consultCountDegrees[i].consultCount,
            name: this.alldata2.consultCountDegrees[i].degree,
            itemStyle: { color: this.alldata2.consultCountDegrees[i].color}
          }
        )
      }
      var myChart = this.$echarts.init(this.$refs.consultCountDegrees);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        title: {
          textStyle: { fontSize: 16, color: '#ffffff' },
          left: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%','70%'],
            center: ['50%','55%'],
            label: {show: true,formatter(param) {return param.name + '(' + param.percent + '%)'}},
            data: yx
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    crisisNumByRoles(){
      var yx = []
      var sl = []
      for(var i = 0;i<this.alldata3.crisisNumByRoles.length;i++){
        yx.push(
          {
            value: this.alldata3.crisisNumByRoles[i].crisisCount,
            name: this.alldata3.crisisNumByRoles[i].degree,
            itemStyle: { color: this.alldata3.crisisNumByRoles[i].color}
          }
        )
      }
      var myChart = this.$echarts.init(this.$refs.crisisNumByRoles);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        title: {
          textStyle: { fontSize: 16, color: '#ffffff' },
          left: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%','70%'],
            center: ['50%','55%'],
            label: {show: true,formatter(param) {return param.name + '(' + param.percent + '%)'}},
            data: yx
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    crisisNumByRoles2(){
      var yx = []
      var sl = []

      for(var i = 0;i<this.alldata3.crisisNumByRoles1.length;i++){
        yx.push(
          {
            value: this.alldata3.crisisNumByRoles1[i].crisisCount,
            name: this.alldata3.crisisNumByRoles1[i].degree,
            itemStyle: { color: this.alldata3.crisisNumByRoles1[i].color}
          }
        )
      }
      var myChart = this.$echarts.init(this.$refs.crisisNumByRoles2);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        title: {
          textStyle: { fontSize: 16, color: '#ffffff' },
          left: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%','70%'],
            center: ['50%','55%'],
            label: {show: true,formatter(param) {return param.name + '(' + param.percent + '%)'}},
            data: yx
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    crisisNumBySexes(){
      
      // var yx = []
      // var sl = []

      // for(var i = 0;i<this.alldata3.crisisNumBySexes.length;i++){
      //   yx.push(
      //     {
      //       value: this.alldata3.crisisNumBySexes[i].womanCount,
      //       name: this.alldata3.crisisNumBySexes[i].manCount,
      //       // itemStyle: { color: this.alldata2.crisisNumByRoles[i].color}
      //     }
      //   )
      // }
      var myChart = this.$echarts.init(this.$refs.crisisNumBySexes);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        title: {
          textStyle: { fontSize: 16, color: '#ffffff' },
          left: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%','70%'],
            center: ['50%','55%'],
            label: {show: true,formatter(param) {return param.name + '(' + param.percent + '%)'}},
            data: [
              {
                value: this.alldata3.crisisNumBySexes.manCount3,
                name: "男性三级危机等级",
                itemStyle: { color: 'rgba(96, 219, 156, 1)'}
              },
              {
                value: this.alldata3.crisisNumBySexes.manCount4,
                name: "男性四级危机等级",
                itemStyle: { color: 'rgba(7, 193, 96, 1)'}
              },
              {
                value: this.alldata3.crisisNumBySexes.manCount5,
                name: "男性五级危机等级",
                itemStyle: { color: 'rgba(1, 130, 64, 1)'}
              },
              
              {
                value: this.alldata3.crisisNumBySexes.womanCount3,
                name: "女性三级危机等级",
                itemStyle: { color: 'rgba(117, 194, 235, 1)'}
              },
              {
                value: this.alldata3.crisisNumBySexes.womanCount4,
                name: "女性四级危机等级",
                itemStyle: { color: 'rgba(60, 177, 240, 1)'}
              },
              {
                value: this.alldata3.crisisNumBySexes.womanCount5,
                name: "女性五级危机等级",
                itemStyle: { color: 'rgba(8, 129, 194, 1)'}
              },
            ]
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    consultCountCampusDegrees(){//1111111111111111111111
      var myChart = this.$echarts.init(this.$refs.consultCountCampusDegrees);
      var serieslist = []
      var zxs = []
      this.alldata2.consultCountCampusDegrees.forEach((itemm,i) => {
          var yx1 = []
          yx1.push(itemm.name)
          var yx2 = []
          itemm.list.forEach((btem,i) => {
            zxs.push(btem.campus)
            yx2.push(btem.consultCount)
          });
          serieslist.push(
            {
              name: yx1,
              type: 'bar',
              stack: 'total',
              label: {
                show: true
              },
              lineStyle: {width: 2,type: 'dashed'},
              emphasis: {
                focus: 'series'
              },
              barWidth:'20px',
              itemStyle: {color: itemm.color},
              data:yx2
            },
          )
      });

      const newArr = Array.from(new Set(zxs));
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {y: "0%",textStyle: {color: '#ffffff'},itemHeight: 10},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top:'5%',
          containLabel: true
        },
        textStyle: {color:'rgba(109, 128, 156, 1)'},
        yAxis: {
          type: 'value',
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        xAxis: {
          type: 'category',
          data: newArr,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        series: serieslist
      };

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    crisisNumByDept(){//1111111111111111111111
      var myChart = this.$echarts.init(this.$refs.crisisNumByDept);
      var deptName = []

      var orange = []
      var red = []
      var yellow = []

      this.alldata3.crisisNumByDept.forEach(element => {
        deptName.push(element.deptName)
        orange.push(element.orange)
        red.push(element.red)
        yellow.push(element.yellow)
      });

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {y: "0%",textStyle: {color: '#ffffff'},itemHeight: 10},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top:'5%',
          containLabel: true
        },
        textStyle: {color:'rgba(109, 128, 156, 1)'},
        yAxis: {
          type: 'value',
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        xAxis: {
          type: 'category',
          data: deptName,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        series: [
          {
            name: '红色',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            lineStyle: {width: 2,type: 'dashed'},
            emphasis: {
              focus: 'series'
            },
            barWidth:'20px',
            itemStyle: {color: 'rgba(227, 82, 82, 1)'},
            data:red
          },
          {
            name: '橙色',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            lineStyle: {width: 2,type: 'dashed'},
            emphasis: {
              focus: 'series'
            },
            barWidth:'20px',
            itemStyle: {color: 'rgba(235, 168, 68, 1)'},
            data:orange
          },
          {
            name: '黄色',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            lineStyle: {width: 2,type: 'dashed'},
            emphasis: {
              focus: 'series'
            },
            barWidth:'20px',
            itemStyle: {color: '#ffe172'},
            data:yellow
          },
        ]
      };

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    crisisNumByMonth(){//1111111111111111111111
      var myChart = this.$echarts.init(this.$refs.crisisNumByMonth);
      var deptName = []

      var orange = []
      var red = []
      var yellow = []

      this.alldata3.crisisNumByMonth.forEach(element => {
        deptName.push(element.month)
        orange.push(element.orange)
        red.push(element.red)
        yellow.push(element.yellow)
      });

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {y: "0%",textStyle: {color: '#ffffff'},itemHeight: 10},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top:'5%',
          containLabel: true
        },
        textStyle: {color:'rgba(109, 128, 156, 1)'},
        yAxis: {
          type: 'value',
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        xAxis: {
          type: 'category',
          data: deptName,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        series: [
          {
            name: '红色',
            type: 'line',
            label: {
              show: true
            },
            lineStyle: {width: 2},
            emphasis: {
              focus: 'series'
            },
            barWidth:'20px',
            itemStyle: {color: 'rgba(227, 82, 82, 1)'},
            data:red
          },
          {
            name: '橙色',
            type: 'line',
            label: {
              show: true
            },
            lineStyle: {width: 2,},
            emphasis: {
              focus: 'series'
            },
            barWidth:'20px',
            itemStyle: {color: 'rgba(235, 168, 68, 1)'},
            data:orange
          },
          {
            name: '黄色',
            type: 'line',
            label: {
              show: true
            },
            lineStyle: {width: 2},
            emphasis: {
              focus: 'series'
            },
            barWidth:'20px',
            itemStyle: {color: '#ffe172'},
            data:yellow
          },
        ]
      };

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    crisisNumByDegrees(){
      var aliasName = []
      var crisisCount = []
      var color = []
      for(var i = 0;i<this.alldata3.crisisNumByDegrees.length;i++){
        aliasName.push(this.alldata3.crisisNumByDegrees[i].aliasName)
        crisisCount.push(this.alldata3.crisisNumByDegrees[i].crisisCount)
        // color.push(this.alldata3.crisisNumByDegrees[i].color)
      }
      var myChart = this.$echarts.init(this.$refs.crisisNumByDegrees);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            data: aliasName,
            axisTick: {
              alignWithLabel: true
            },
            axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine:{
              lineStyle:{show:true,color:'rgba(109, 128, 156, 1)',}
            },
            splitLine:{
              lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}
            }
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth: '50px',
            data: crisisCount,
            itemStyle: { color: 'rgba(53, 163, 222, 1)'},
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },


    consultCountCampusRoles(){//2222222222222222222222222222222222222222222222222
      var GetDictionaryList = []
      this.GetDictionaryList.forEach(element => {
        GetDictionaryList.push(element.ConAddressName)
      });
      var serieslist = []
      var zxs = []
      
      this.alldata2.consultCountCampusRoles.forEach((itemm,i) => {
       
          var yx1 = []
          yx1.push(itemm.name)
          var yx2 = []
          itemm.list.forEach((btem,i) => {
            zxs.push(btem.campus)
            yx2.push(btem.consultCount)
          });
          serieslist.push(
            {
              name: yx1,
              type: 'bar',
              stack: 'total',
              label: {
                show: true
              },
              lineStyle: {width: 2,type: 'dashed'},
              emphasis: {
                focus: 'series'
              },
              barWidth:'20px',
              itemStyle: {color: itemm.color},
              data:yx2
            },
          )
      });
      const newArr = Array.from(new Set(zxs));
  
      var myChart = this.$echarts.init(this.$refs.consultCountCampusRoles)
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {y: "0%",textStyle: {color: '#ffffff'},itemHeight: 10},
        // legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top:'5%',
          containLabel: true
        },
        textStyle: {color: 'rgba(109, 128, 156, 1)'},
        yAxis: {
          type: 'value',
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        xAxis: {
          type: 'category',
          data: newArr,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        series: serieslist
      };

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },




    consultCountRoles(){
      var yx = []
      var sl = []


      for(var i = 0;i<this.alldata2.consultCountRoles.length;i++){
        yx.push(
          {
            value: this.alldata2.consultCountRoles[i].consultCount,
            name: this.alldata2.consultCountRoles[i].roleName,
            itemStyle: { color: this.alldata2.consultCountRoles[i].color}
          }
        )
      }


      var myChart = this.$echarts.init(this.$refs.consultCountRoles);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        title: {
          textStyle: { fontSize: 16, color: '#ffffff' },
          left: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%','70%'],
            center: ['50%','55%'],
            label: {show: true,formatter(param) {return param.name + '(' + param.percent + '%)'}},
            data: yx
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    new3(){
      var myChart = this.$echarts.init(this.$refs.new3);
      var appointConsultTimes = [];
      var completeConsultTimes = [];
      var lineConsultTimes = [];
      var scheduleDate = [];
      for(var i = 0; i<this.alldata.appointConsultTimes.length;i++){
        appointConsultTimes.push(this.alldata.appointConsultTimes[i].total)
      }
      for(var i = 0; i<this.alldata.completeConsultTimes.length;i++){
        completeConsultTimes.push(this.alldata.completeConsultTimes[i].total)
      }
      for(var i = 0; i<this.alldata.lineConsultTimes.length;i++){
        lineConsultTimes.push(this.alldata.lineConsultTimes[i].total)
      } 
      for(var i = 0; i<this.alldata.lineConsultTimes.length;i++){
        scheduleDate.push(this.alldata.lineConsultTimes[i].scheduleDate)
      }
      var option = {
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        tooltip: {trigger: 'axis', top:"20px"},
        grid: {left: '3%',right: '4%',bottom: '3%',containLabel: true},

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: scheduleDate,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{show:true,color:'rgba(109, 128, 156, 1)',}
          },
          splitLine:{
            lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}
          }
        },
        series: [
          {
            name: '预约人数',
            type: 'line',
            data: appointConsultTimes,
            itemStyle: { color: 'rgba(60, 177, 240, 1)'},
            symbolSize: 10,
          },
          {
            name: '排队人数',
            type: 'line',
            data: lineConsultTimes,
            itemStyle: { color: 'rgba(255, 195, 0, 1)'},
            symbolSize: 10,
          },
          {
            name: '完成人数',
            type: 'line',
            data: completeConsultTimes,
            itemStyle: { color: 'rgba(19, 186, 86, 1)'},
            symbolSize: 10,
          }
        ]
      };

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    crisisByCampusList(){
      var crisisCount3 = [];
      var crisisCount4 = [];
      var crisisCount5 = [];
      var scheduleDate = [];
      for(var i = 0;i<this.alldata3.crisisByCampusList.length;i++){
        crisisCount3.push(this.alldata3.crisisByCampusList[i].crisisCount3)
        crisisCount4.push(this.alldata3.crisisByCampusList[i].crisisCount4)
        crisisCount5.push(this.alldata3.crisisByCampusList[i].crisisCount5)
        scheduleDate.push(this.alldata3.crisisByCampusList[i].scheduleDate)
      }
      var myChart = this.$echarts.init(this.$refs.crisisByCampusList);
      var option = {
        tooltip: {trigger: 'axis', top:"20px"},
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        grid: {left: '3%',right: '4%',bottom: '3%',containLabel: true},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: scheduleDate,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{show:true,color:'rgba(109, 128, 156, 1)',}
          },
          splitLine:{
            lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}
          }
        },
        series: [
          {
            name: '中度',
            type: 'line',
            stack: 'Total',
            data: crisisCount3,
            itemStyle: { color: 'rgb(255 198 0)'},
            symbolSize: 10,
          },
          {
            name: '较重',
            type: 'line',
            stack: 'Total',
            data: crisisCount4,
            itemStyle: { color: 'rgb(255 102 0)'},
            symbolSize: 10,
          },
          {
            name: '重度',
            type: 'line',
            stack: 'Total',
            data: crisisCount5,
            itemStyle: { color: 'rgb(226, 48, 115)'},
            symbolSize: 10,
          }
        ]
      };
      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    appointConsultByThemes(){
      var total1 =[]//预约人数
      var total2 =[]//排队人数
      var total3 =[]//完成咨询人数
      var scheduleDate =[]//日期

      for(var i = 0; i<this.alldata2.appointConsultByThemes.length;i++){
        total1.push(this.alldata2.appointConsultByThemes[i].total)
      }

      for(var i = 0; i<this.alldata2.lineConsultThemes.length;i++){
        total2.push(this.alldata2.lineConsultThemes[i].total)
      }

      for(var i = 0; i<this.alldata2.completeConsultThemes.length;i++){
        total3.push(this.alldata2.completeConsultThemes[i].total)
      }

      for(var i = 0; i<this.alldata2.completeConsultThemes.length;i++){
        scheduleDate.push(this.alldata2.completeConsultThemes[i].schedulDate)
      }

    

      var myChart = this.$echarts.init(this.$refs.appointConsultByThemes);
      var option = {
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        tooltip: {trigger: 'axis', top:"20px"},
        grid: {left: '3%',right: '4%',bottom: '3%',containLabel: true},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: scheduleDate,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{show:true,color:'rgba(109, 128, 156, 1)',}
          },
          splitLine:{
            lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}
          }
        },
        series: [
          {
            name: '预约人次',
            type: 'line',
            stack: 'Total',
            data: total1,
            itemStyle: { color: 'rgba(60, 177, 240, 1)'},
            symbolSize: 10,
          },
          {
            name: '排队人次',
            type: 'line',
            stack: 'Total',
            data: total2,
            itemStyle: { color: 'rgba(255, 195, 0, 1)'},
            symbolSize: 10,
          },
          {
            name: '完成人次',
            type: 'line',
            stack: 'Total',
            data: total3,
            itemStyle: { color: 'rgba(19, 186, 86, 1)'},
            symbolSize: 10,
          }
        ]
      };

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    news1(){
      var total1 =[]//预约人数
      var total2 =[]//排队人数
      var total3 =[]//完成咨询人数
      var scheduleDate =[]//日期
      for(var i = 0; i<this.alldata2.appointConsultTimes.length;i++){
        total1.push(this.alldata2.appointConsultTimes[i].total)
      }
      for(var i = 0; i<this.alldata2.lineConsultTimes.length;i++){
        total2.push(this.alldata2.lineConsultTimes[i].total)
      }
      for(var i = 0; i<this.alldata2.completeConsultTimes.length;i++){
        total3.push(this.alldata2.completeConsultTimes[i].total)
      }
      for(var i = 0; i<this.alldata2.completeConsultTimes.length;i++){
        scheduleDate.push(this.alldata2.completeConsultTimes[i].scheduleDate)
      }
      var myChart = this.$echarts.init(this.$refs.news1);
      var option = {
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        tooltip: {trigger: 'axis', top:"20px"},
        grid: {left: '3%',right: '4%',bottom: '3%',containLabel: true},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: scheduleDate,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{show:true,color:'rgba(109, 128, 156, 1)',}
          },
          splitLine:{
            lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}
          }
        },
        series: [
          {
            name: '预约人次',
            type: 'line',
            stack: 'Total',
            data: total1,
            itemStyle: { color: 'rgba(60, 177, 240, 1)'},
            symbolSize: 10,
          },
          {
            name: '排队人次',
            type: 'line',
            stack: 'Total',
            data: total2,
            itemStyle: { color: 'rgba(255, 195, 0, 1)'},
            symbolSize: 10,
          },
          {
            name: '完成人次',
            type: 'line',
            stack: 'Total',
            data: total3,
            itemStyle: { color: 'rgba(19, 186, 86, 1)'},
            symbolSize: 10,
          }
        ]
      };

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    studentCounts(){
      var arr1 = []
      var arr2 = []
      var arr3 = []
      this.alldata.studentCounts.forEach((item,i) => {
        arr1.push(item.deptName)
        arr2.push(item.activityCount)
        arr3.push(item.trainingCount)
      });

 
      var myChart = this.$echarts.init(this.$refs.studentCounts);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {y: "0%",textStyle: {color: '#ffffff'},itemHeight: 10},
        // legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top:'5%',
          containLabel: true
        },
        textStyle: {color: 'rgba(109, 128, 156, 1)'},
        xAxis: {
          type: 'value',
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        yAxis: {
          type: 'category',
          data: arr1,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        series: [
          {
            name: '活动',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            lineStyle: {width: 2,type: 'dashed'},
            emphasis: {
              focus: 'series'
            },
            barWidth:'20px',
            itemStyle: {color: 'rgba(7, 193, 96, 1)'},
            data:arr2
          },
          {
            name: '教育培训',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            lineStyle: {width: 2,type: 'dashed'},
            emphasis: {
              focus: 'series'
            },
            itemStyle: {color: 'rgb(240, 188, 17)'},
            barWidth:'20px',
            data: arr3
          }
        ]
      };

      myChart.setOption(option,true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });


    },
  },
}
</script>
<style>
:root {
  --Monthly1: rgba(30, 45, 66, 1);
  --Monthly2: rgb(255 255 255);
  --Monthly3: rgb(240, 188, 17);
  --Monthly4: #f8f8f8;
  --Monthly5: #f8f8f8;
}
.Monthly .el-button{padding: 10px 20px;background-color: rgb(75, 108, 166);border: rgb(75, 108, 166);}
.Monthly{width: 100%;position: relative;}
.Monthly .Monthly_top{height: 80px;width: 100% ;background: linear-gradient(180deg, rgba(54, 85, 138, 1) 0%, rgba(57, 89, 143, 1) 100%);}
.Monthly .Select{color: rgba(255, 255, 255, 1) !important;}
.Monthly .Select2{color: rgba(255, 255, 255, 1) !important;background: rgba(82, 111, 161, 1) !important;}
.triangle-down {width: 0;height: 0;border-left: 6px solid transparent;border-right: 6px solid transparent;border-bottom: 12px solid rgb(255, 255, 255);position: absolute;top: 68px;left: 25px;}
.Monthly .nav{height: calc(100% - 80px);background: var(--Monthly1);opacity: 1;position: absolute;left: 0px;z-index: 10;min-height: 1200px;width: 100%; }
.Monthly .nav1{height: calc(100% - 80px);background: var(--Monthly1);opacity: 1;position: absolute;left: 0px;z-index: 10;min-height: 2200px;top: 80px;z-index: 99;height: 3535px;}
.Monthly .nav3{height: calc(100% - 80px);background: var(--Monthly1);opacity: 1;width: 100%;position: absolute;top: 80px;left: 0px;z-index: 10;min-height: 1700px;height: 3535px;}
.Monthly .nav4{height: calc(100% - 80px);background: linear-gradient(180deg, rgba(30, 45, 66, 1) 0%, rgba(38, 44, 54, 1) 100%);opacity: 1;width: 100%;position: absolute;top: 80px;left: 0px;z-index: 10;min-height: 1700px;}
.el-dropdown { vertical-align: top;}
.el-dropdown + .el-dropdown { margin-left: 15px;}
.el-icon-arrow-down {font-size: 12px;}
.Monthly .yuefen .el-input__inner{background-color:rgba(75, 108, 166, 1);border:1px solid rgba(75, 108, 166, 1);color: #fff;border-radius:0px}
.nav-ul {width: calc(100% - 40px);margin-left: 20px;margin-top: 20px;height: 200px;}
.nav-ul li{float: left;width: calc(33.3% - 2px);float: left;height: 100%;border: 1px solid rgba(109, 128, 156, 1);}
.Monthly .complete{width: calc(100% - 42px);margin-left: 20px;margin-top: 20px;height: 300px;}
.Monthly .complete2{width: calc(100% - 42px);margin-left: 20px;margin-top: 20px;height: 330px;margin-top: 20px;border: 1px solid  rgba(109, 128, 156, 1);}
.Monthly .complete2 li{float: left;height: 100%;}
.Monthly .complete2 .item div{width: 100% !important;}
.Monthly .complete2 li canvas {height: 285px !important;width: 100% !important;}
.Monthly .complete3{width: calc(100% - 42px);margin-left: 20px;margin-top: 20px;height: 600px;margin-top: 20px;border: 1px solid  rgba(109, 128, 156, 1);}
.Monthly .complete4{width: calc(100% - 42px);margin-left: 20px;margin-top: 20px;height: 640px;margin-top: 20px;border: 1px solid  rgba(109, 128, 156, 1);}
.Monthly .complete4 li{float: left;height: 100%;}
.Monthly .complete4 li canvas {height: 285px !important;}
.Monthly .complete3 li{float: left;height: 100%;}
.Monthly .complete3 li div{width: 100% !important;}
.Monthly .complete3 li canvas {height: 285px !important;width: 100%;}
.no{opacity: 0 !important;position: absolute;top: 80px;left: 0px;z-index: 0 !important;}
.biaoge table {width: 100%;border-collapse: collapse;border-spacing: 0;border: 1px solid rgba(109, 128, 156, 1);color: rgba(255, 255, 255, 1);text-align: center;}
.biaoge table td {border: 1px solid rgba(109, 128, 156, 1);padding: 0;height: 40px;}
.Monthly .sjli{margin-top: 20px;color: var(--Monthly2);}
.Monthly .sjli li{float: left;padding: 6px 20px;}
.Monthly .sjli .aa{background-color: rgba(19, 186, 86, 1);color: #fff;border-radius: 15px;}
.fffs{background-color: rgba(19, 186, 86, 1);color: #fff;border-radius: 15px;}
</style>
